"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISearchInput = _interopRequireDefault(require("UIComponents/input/UISearchInput"));

var _Checkbox = _interopRequireDefault(require("../inputs/Checkbox"));

var _ExpandableFilter = _interopRequireDefault(require("./ExpandableFilter"));

var IntegrationsToggleGroup = function IntegrationsToggleGroup(_ref) {
  var appIntegrations = _ref.appIntegrations,
      onChange = _ref.onChange,
      trackInteraction = _ref.trackInteraction,
      value = _ref.value;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      searchTerm = _useState2[0],
      setSearchTerm = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      searchTracked = _useState4[0],
      setSearchTracked = _useState4[1];

  var trackSearch = (0, _react.useCallback)(function () {
    if (!searchTracked) {
      trackInteraction('search app integrations');
      setSearchTracked(true);
    }
  }, [searchTracked, trackInteraction]);
  var handleChange = (0, _react.useCallback)(function (_ref2) {
    var _ref2$target = _ref2.target,
        checked = _ref2$target.checked,
        inputValue = _ref2$target.value;
    onChange(checked ? value.add(inputValue) : value.delete(inputValue));
  }, [onChange, value]);
  var renderedInputs = (0, _react.useMemo)(function () {
    return appIntegrations.filter(function (integration) {
      if (searchTerm) {
        var searchRegex = new RegExp(searchTerm, 'i');
        return searchRegex.test(integration);
      }

      return true;
    }).map(function (integration) {
      return _react.default.createElement(_Checkbox.default, {
        key: integration,
        checked: value.includes(integration),
        onChange: handleChange,
        value: integration
      }, integration);
    });
  }, [appIntegrations, handleChange, searchTerm, value]);
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UIFormControl.default, {
    "aria-label": "integrations"
  }, _react.default.createElement(_UISearchInput.default, {
    onBlur: function onBlur() {
      setSearchTracked(false);
    },
    onChange: function onChange(_ref3) {
      var searchValue = _ref3.target.value;

      if (searchValue.trim()) {
        setSearchTerm(searchValue);
        trackSearch();
      } else {
        setSearchTerm('');
      }
    },
    placeholder: (0, _unescapedText.default)('appMarketplace.storefront.filters.integrations.searchInputPlaceholder')
  })), _react.default.createElement(_ExpandableFilter.default, {
    name: "integrations"
  }, renderedInputs));
};

IntegrationsToggleGroup.propTypes = {
  appIntegrations: _reactImmutableProptypes.default.orderedSet.isRequired,
  onChange: _propTypes.default.func.isRequired,
  trackInteraction: _propTypes.default.func.isRequired,
  value: _reactImmutableProptypes.default.iterableOf(_propTypes.default.string).isRequired
};
var _default = IntegrationsToggleGroup;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/filters/IntegrationsToggleGroup.js
// module id = 729
// module chunks = 209 210 211 212